import { History, FolderArchive } from "lucide-react";

import { PageTabs, PageTabItem } from "@/components/shared/PageTabs";
import { TopBarSection } from "@/components/shared/SecaoBarraSuperior";

import { ArquivoListTable } from "./components/ArquivoListTable";
import { ArquivoLogListTable } from "./components/ArquivoLogListTable";

const tabs: PageTabItem[] = [
  {
    value: "arquivos",
    label: "Arquivos",
    icon: FolderArchive,
    content: <ArquivoListTable />,
  },
  {
    value: "historico",
    label: "Histórico de Downloads",
    icon: History,
    content: <ArquivoLogListTable />,
  },
];

const ArquivosAdminPage = () => {
  return (
    <div className="space-y-6 pb-10 duration-500 animate-in fade-in">
      <TopBarSection
        entity="Admin"
        title="Arquivos do Sistema"
        subtitle="Auditoria de arquivos e histórico de ações"
      />

      <PageTabs tabs={tabs} />
    </div>
  );
};

export default ArquivosAdminPage;
